export default "__VITE_ASSET__Dj28Wtau__"